// ! This file was auto-generated from the sylvanus OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    acceptDisclaimerApiV1UserAcceptDisclaimerPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.conversation, id: "LIST" }, { type: Tags.disclaimer, id: "LIST" }]
    },
    acceptDisclaimerApiV1WdInternalUserAcceptDisclaimerPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.private_conversation, id: "LIST" }, { type: Tags.disclaimer, id: "LIST" }]
    },
    addDocumentsToExtractionTableApiV1DdeTableTableIdUploadPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    checkDocInModelScopeApiV1InternalModelModelIdVersionVersionNumberCheckScopeGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.internal, id: arg.modelId }]
    },
    createAgentExecutionMessageApiV1AgentExecutionAeIdMessagePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.aeId }]
    },
    createDdeModelInitialVersionApiV1DdeTableTableIdModelPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    createDdeModelVersionApiV1DdeTableTableIdModelModelIdVersionPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    createExtractionTableApiV1DdeTablesPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.dde, id: "LIST" }]
    },
    createGroupPredictionWorkflowInternalApiV1InternalModelModelIdGroupPredictPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }, { type: Tags.internal, id: arg.modelId }, { type: Tags.internal, id: "LIST" }]
    },
    createMessageApiV1ConversationConversationIdMessagePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    createMessageInternalApiV1WdInternalConversationConversationIdMessagePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    createModelApiV1ModelPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }]
    },
    createModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcasePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    createModelVersionApiV1ModelModelIdVersionPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    createNewLibraryModelApiV1LibraryModelPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.library, id: "LIST" }]
    },
    createNewLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.library, id: arg.libraryModelId }, { type: Tags.library, id: "LIST" }]
    },
    createPredictionWorkflowExternalApiV1ModelModelIdPredictPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    createPredictionWorkflowInternalApiV1InternalModelModelIdPredictPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }, { type: Tags.internal, id: arg.modelId }, { type: Tags.internal, id: "LIST" }]
    },
    declineDisclaimerApiV1UserDeclineDisclaimerPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.conversation, id: "LIST" }, { type: Tags.disclaimer, id: "LIST" }]
    },
    declineDisclaimerApiV1WdInternalUserDeclineDisclaimerPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.private_conversation, id: "LIST" }, { type: Tags.disclaimer, id: "LIST" }]
    },
    deleteAgentExecutionApiV1AgentExecutionAeIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.aeId }]
    },
    deleteConversationApiV1ConversationConversationIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    deleteConversationApiV1WdInternalConversationConversationIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    deleteDdeModelApiV1DdeTableTableIdModelModelIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    deleteExtractionTableApiV1DdeTableTableIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    deleteLibraryModelApiV1LibraryModelLibraryModelIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.library, id: arg.libraryModelId }, { type: Tags.library, id: "LIST" }]
    },
    deleteLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.library, id: arg.libraryModelId }, { type: Tags.library, id: "LIST" }]
    },
    deleteModelApiV1ModelModelIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    deleteWorkflowApiV1ModelModelIdPublishDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    executeTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberExecutePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    executeVersionTestcasesApiV1ModelModelIdVersionVersionNumberExecutePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    generateClauseApiV1ClauseGeneratePost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.clause, id: "LIST" }]
    },
    getAiMessageApiV1ConversationConversationIdAiMessagePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    getAiMessageInternalApiV1WdInternalConversationConversationIdAiMessagePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    getAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.aeId }]
    },
    getAiMessageStreamApiV1ConversationConversationIdAiMessageStreamPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    getAiMessageStreamInternalApiV1WdInternalConversationConversationIdAiMessageStreamPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    getAllPredictionForModelLastPublishApiV1ModelModelIdPredictGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getBackgroundAgentStreamApiV1AgentExecutionAeIdAiMessageStreamGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.aeId }]
    },
    getConversationApiV1ConversationConversationIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }]
    },
    getConversationApiV1WdInternalConversationConversationIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }]
    },
    getDocsInScopeApiV1ModelDocsInScopePost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }]
    },
    getExecuteVersionTestcasesStreamApiV1ModelModelIdVersionVersionNumberExecuteGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getExecutionApiV1AgentExecutionAgentExecutionIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.agentExecutionId }]
    },
    getExtractionTableApiV1DdeTableTableIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }]
    },
    getExtractionTableRowsApiV1DdeTableTableIdRowsGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }]
    },
    getLibraryModelApiV1LibraryModelLibraryModelIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.library, id: arg.libraryModelId }]
    },
    getLibraryModelPublishStatusApiV1LibraryModelPublishGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.library, id: "LIST" }]
    },
    getLibraryModelsApiV1LibraryModelGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.library, id: "LIST" }]
    },
    getLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.library, id: arg.libraryModelId }]
    },
    getModelApiV1ModelModelIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getModelInternalViewApiV1InternalModelModelIdIdentityGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.internal, id: arg.modelId }]
    },
    getModelProgressApiV1ModelModelIdProgressGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getModelsForEntityApiV1ModelsEntityTypeEntityIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.entityType }]
    },
    getModelSummaryApiV1ModelsSummaryGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }]
    },
    getModelSummaryForClientApiV1ModelsClientClientIdSummaryGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.clientId }, { type: Tags.platform_admin, id: arg.clientId }]
    },
    getModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getModelVersionApiV1ModelModelIdVersionVersionNumberGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getOptimizeApiV1ModelModelIdVersionVersionNumberOptimizeGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getOptimizeSummaryApiV1ModelModelIdVersionVersionNumberOptimizeSummaryGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getPredictionForDocumentApiV1ModelModelIdPredictEntityTypeEntityIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    getPublishWorkflowApiV1ModelModelIdPublishGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    healthcheckHealthGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.healthcheck, id: "LIST" }]
    },
    healthcheckHealthShallowGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.healthcheck, id: "LIST" }]
    },
    interruptAgentExecutionApiV1AgentExecutionAeIdInterruptPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.aeId }]
    },
    interruptConversationApiV1ConversationConversationIdInterruptPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    interruptConversationApiV1WdInternalConversationConversationIdInterruptPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    listAgentExecutionsApiV1AgentExecutionsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.agent_execution, id: "LIST" }]
    },
    listConversationsApiV1ConversationsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.conversation, id: "LIST" }]
    },
    listConversationsApiV1WdInternalConversationsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.private_conversation, id: "LIST" }, { type: Tags.conversation, id: "LIST" }]
    },
    listDdeModelsApiV1DdeTableTableIdModelsGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }]
    },
    listExtractionTablesApiV1DdeTablesGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.dde, id: "LIST" }]
    },
    listModelsApiV1ModelGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }]
    },
    listModelsInternalApiV1InternalModelGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }, { type: Tags.internal, id: "LIST" }]
    },
    listTargetedEntitiesApiV1ModelTargetedEntitiesGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }, { type: Tags.no_rbac, id: "LIST" }]
    },
    listTargetEntitiesApiV1ModelTargetEntitiesGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }, { type: Tags.no_rbac, id: "LIST" }]
    },
    modelConfigCheckApiV1ModelConfigCheckPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }]
    },
    modelConfigSuggestApiV1ModelModelIdConfigSuggestGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }]
    },
    modelConfigSuggestInitialApiV1ModelConfigSuggestPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.model, id: "LIST" }]
    },
    newAgentExecutionApiV1AgentExecutionPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.agent_execution, id: "LIST" }]
    },
    newConversationApiV1ConversationPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.conversation, id: "LIST" }]
    },
    newConversationWdInternalApiV1WdInternalConversationPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.private_conversation, id: "LIST" }, { type: Tags.conversation, id: "LIST" }]
    },
    publishLibraryModelsApiV1LibraryModelPublishPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.library, id: "LIST" }]
    },
    publishModelApiV1ModelModelIdPublishPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    redlineClauseApiV1ClauseRedlinePost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.clause, id: "LIST" }]
    },
    removeDocumentsFromExtractionTableApiV1DdeTableTableIdDocumentHandlerIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    renameExtractionTableApiV1DdeTableTableIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    rerunPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    runExtractionApiV1DdeTableTableIdExtractPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.dde, id: arg.tableId }, { type: Tags.dde, id: "LIST" }]
    },
    suspendPublishWorkflowApiV1ModelModelIdSuspendPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    triggerInternalOptimizeApiV1InternalModelModelIdVersionVersionNumberOptimizePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }, { type: Tags.internal, id: arg.modelId }, { type: Tags.internal, id: "LIST" }]
    },
    triggerOptimizeApiV1ModelModelIdVersionVersionNumberOptimizePost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    updateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.agent_execution, id: arg.aeId }]
    },
    updateConversationApiV1ConversationConversationIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    updateConversationApiV1WdInternalConversationConversationIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    updateMessageApiV1ConversationConversationIdMessageMessageIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    updateMessageApiV1WdInternalConversationConversationIdMessageMessageIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.private_conversation, id: arg.conversationId }, { type: Tags.conversation, id: arg.conversationId }, { type: Tags.conversation, id: "LIST" }]
    },
    updateModelProgressApiV1ModelModelIdProgressPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    },
    updateModelProgressInternalApiV1InternalModelModelIdProgressPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }, { type: Tags.internal, id: arg.modelId }, { type: Tags.internal, id: "LIST" }]
    },
    updateTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.model, id: arg.modelId }, { type: Tags.model, id: "LIST" }]
    }
} as const;
